import { useAuth0 } from '@auth0/auth0-react'
import { GraphQLTagRepository } from 'infrastructure/graphql/TagRepositoryImpl'
import { useCallback, useState } from 'react'

export function useDeleteTag() {
  const { getIdTokenClaims } = useAuth0()
  const [deleting, setDeleting] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const deleteTag = useCallback(
    async (campaignID: string, inventoryID: string) => {
      setDeleting(true)
      setError(null)
      try {
        const getToken = async () => (await getIdTokenClaims())?.__raw ?? ''
        const repo = new GraphQLTagRepository(getToken)
        await repo.delete(campaignID, inventoryID)
      } catch (err: any) {
        setError(err)
        throw err
      } finally {
        setDeleting(false)
      }
    },
    [getIdTokenClaims]
  )
  return { deleteTag, deleting, error }
}
